import { Injectable } from '@angular/core';
import { CanActivate } from '@nestjs/common';
import { AuthService } from '@balloon-race-fullstack-monorepo/dbr-common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {

  constructor(public auth: AuthService,
              public router: Router,
  ) {
  }

  canActivate(): boolean {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
